import React from "react";

import styles from "./DateTime.module.scss";

export const DashDateTimeContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div
    className={`${styles.dashDateTimeContainer} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
);
